import React, { Component } from "react";
import { Button } from 'antd';
import { ajax, unparam, createTimeStr, hex2Rgba } from "../../../utils/common";
import VideoPlayer from "components/videoPlayer";
import Report from "./report";
import Tabs from "components/tabs";
import Bulk from "./reportItems/bulk";
import PrimaryVideo from "./primaryVideo";
//css
import "./index.less";
// 国际化
import i18nZh_cn from "utils/zh_cn";
import i18nEn_us from "utils/en_us";

const { TabPanel } = Tabs;

class App extends Component {

    tabRef = React.createRef();

	state = {
		userInfo: {},
		paperInfo: {},
		videoUrl: "",
		selectedIndex: 0,
		accountId: "",
		finishStatus: -1,
		showMorePaperinfo: false,
		autoPlay: false,
		themeColor: "#00C3D5",	//页面主色: #00C3D5
        summary: {},
        result: {},
        currentResult: {},
        inkbarLeft: 0,
        showGenerate: true,
        showLoading: false
	}

	componentDidMount() {
		//获取页面参数
		const queryString = unparam(location.search);
        // 国际化
        const lang = queryString.lang ? queryString.lang.toLocaleLowerCase() : "zh_cn";
        const i18n = lang === "en_us" ? i18nEn_us : i18nZh_cn;
        const inkbarLeft = document.documentElement.clientWidth/3/2-15;
        this.setState({
            i18n,
            inkbarLeft
        })
		//获取页面主色
		const themeColor = queryString.themeColor ? queryString.themeColor : this.state.themeColor;
  		// 获取账号信息
  		ajax({
	      	url: "/rept/account/getAccountById",
	      	data: {
	        	accountId: queryString.accountId,
                timestamp: queryString.timestamp,
                sign: queryString.sign,
	      	}
	    }).then(account => {
			document.title = account.data.userName + "-" + i18n.index.subtitle2;
	    	this.setState({
	    		finishStatus: account.data.status,
				accountId: queryString.accountId,
	    		userInfo: account.data,
	    		themeColor: themeColor.indexOf("#") >= 0 ? themeColor : ("#" + themeColor)
	    	})
	      	// if (account.data.status === 1) {
				this.getPaper(queryString.accountId, true, queryString.timestamp, queryString.sign);
	      	// }

            if(account.data.aiVaild === 1 || account.data.reportStatus !== 0){
                //获取视频AI分析汇每秒数据
                ajax({
                    url: "/api/file/videoReport/result",
                    data: {
                        accountId: queryString.accountId
                    }
                }).then(res => {
                    this.setState({
                        result: res.data.processing_result_detailed
                    })
                }).catch(err => {
                    console.log("result fail: ", err)
                })
                //获取视频AI分析汇总数据
                ajax({
                    url: "/api/file/videoReport/summary",
                    data: {
                        accountId: queryString.accountId
                    }
                }).then(res => {
                    this.setState({
                        summary: res.data,
                        currentResult: res.data.video_summary ? res.data.video_summary : {}
                    })
                }).catch(err => {
                    console.log("summary fail: ", err)
                })
            }
            if(account.data.reportStatus != 2 || account.data.reportStatus != 3){
                // 2: 报告已生成，3: 报告生成失败
                /* 定时1分钟去获取报告状态 */
                const timer = setInterval(() => {
                    ajax({
                        url: "/rept/account/getAccountById",
                        data: {
                            accountId: queryString.accountId,
                            timestamp: queryString.timestamp,
                            sign: queryString.sign,
                            isAccess: 1
                        }
                    }).then(res => {
                        const userInfo = res.data;
                        if(userInfo.reportStatus == 2 || userInfo.reportStatus == 3){
                            this.setState({ userInfo })
                            clearInterval(timer);
                        }
                    }).catch(err => {
                        console.log("fail: ", err)
                    })
                }, 60000)
            }
	    }).catch(err => {
			if(err.data.status === 5){
				this.setState({
					finishStatus: 1,
					accountId: queryString.accountId,
					userInfo: err.data,
					themeColor: themeColor.indexOf("#") >= 0 ? themeColor : ("#" + themeColor)
				})
			}else{
				this.setState({
					finishStatus: 0,
					accountId: queryString.accountId,
					userInfo: err.data,
					themeColor: themeColor.indexOf("#") >= 0 ? themeColor : ("#" + themeColor)
				})
			}
            this.getPaper(queryString.accountId, false, queryString.timestamp, queryString.sign);
	    })
	}


	//获取试卷
	getPaper = (accountId, showVideo = false, timestamp, sign) => {
		ajax({
			url: "/rept/paper/getPaperById",
			data: {
				accountId,
                timestamp,
                sign,
			}
		}).then(res => {
			//试卷列表
			const interviewQuesVOs = res.data.interviewQuesVOs;
			this.setState({
				paperInfo: res.data
			}, () => {
				//获取第一个视频的url
				showVideo && this.handleClick(interviewQuesVOs[0].questionId, 0);
			})
		})
	}

	handleClick = (qId, index, autoPlay) => {
		//设置选中题号
		this.setState({
			selectedIndex: index,
			autoPlay: autoPlay || false,
            videoUrl: ""
		})
		//账号删除的情况下无法查看视频
		if(this.state.userInfo.status === 5){
			return false;
		}
        const { accountId, paperInfo } = this.state;
		//获取视频的url
		ajax({
			url: "/api/file/viewVideo",
			data: {
				accountId: this.state.accountId,
				paperId: this.state.paperInfo.paperId,
				questionId: qId
			}
		}).then(res => {
			this.setState({
				videoUrl: "/oivi/api/file/review/"+ res.data.videoFileUrl
			})
            const tabObj = this.tabRef.current;
            tabObj && tabObj.switchTabs(0);
		})
	}

	showPaperinfo = () => {
		this.setState({
			showMorePaperinfo: !this.state.showMorePaperinfo
		})
	}

	playEnd = () => {
		const { selectedIndex, paperInfo } = this.state;
		if(selectedIndex < paperInfo.interviewQuesVOs.length - 1){
			const index = selectedIndex + 1;
			const currentQuestion = paperInfo.interviewQuesVOs[index];
			this.handleClick(currentQuestion.questionId, index, true);
		}
	}

	canPlay = () => {
		if(this.state.autoPlay){
			// this.videoPlayer.current.play();
		}
	}
    //下一个视频
    forward = () => {
        const { selectedIndex, paperInfo } = this.state;
        if(selectedIndex < paperInfo.interviewQuesVOs.length - 1){
            const index = selectedIndex + 1;
            const currentQuestion = paperInfo.interviewQuesVOs[index];
            this.handleClick(currentQuestion.questionId, index);
        }
    }
    //上一个视频
    backward = () => {
        const { selectedIndex, paperInfo } = this.state;
        if(selectedIndex > 0){
            const index = selectedIndex - 1;
            const currentQuestion = paperInfo.interviewQuesVOs[index];
            this.handleClick(currentQuestion.questionId, index);
        }
    }

	// 下载报告
	downloadReport = () => {
		window.open(`/oivi/account/downloadVideoReport?accountId=${this.state.accountId}`);
	}

	// 生成报告
	generateReport = () => {
		const { i18n, showLoading } = this.state;
		if(showLoading) return false;
		this.setState({
			showLoading: true
		})
		ajax({
			url: "/account/analyzeExpression"
		}).then(res => {
			message.success(i18n.report.uploadSuccess);
			this.setState({
				showGenerate: false,
				showLoading: false
			})
		}).catch(err => {
			message.error(i18n.report.uploadFail);
		})
	}

    handleTabChange = (index) => {
        const tabsItemEl = document.querySelectorAll(".video-tabs>.tabs-item-wrap-app .tabs-item-app")[index];
        const offsetLeft = tabsItemEl.offsetLeft;
        const clientWidth = tabsItemEl.clientWidth;
        this.setState({
            inkbarLeft: offsetLeft + (clientWidth - 30)/2
        })
        if(index == 1 || index == 2){
            ajax({
                url: "/api/file/videoReport/result",
                data: {
                    accountId: this.state.accountId
                }
            }).then(res => {
                this.setState({
                    videoUrl: "/oivi/api/file/videoReport/video?accountId=" + this.state.accountId,
                    result:res.data.processing_result_detailed
                })
            }).catch(err => {
                console.log("result fail: ", err)
            })
        }else if(index == 0){
            const { selectedIndex, paperInfo } = this.state;
            const currentQuestion = paperInfo.interviewQuesVOs[selectedIndex];
            this.handleClick(currentQuestion.questionId, selectedIndex);
        }
    }

    handleTimeUpdate = (currentTime) => {
        const { result } = this.state;
        if(!result["1"]) return false;
        if(!currentTime) return false;
        const index = (parseInt(currentTime/0.03333) || 1) + "";
        let currentResult = result[index]["0"] || {};
        currentResult.emos = currentResult.emos || {};
        currentResult.char = currentResult.char || {};
        for(let k in currentResult){
            let item = currentResult[k];
            for(let key in item){
                currentResult[k][key] = parseFloat((item[key] * 100).toFixed(2));
            }
        }
        this.setState({
            currentResult
        })
    }

    render() {
        const { i18n, userInfo, paperInfo, themeColor, finishStatus, showMorePaperinfo, selectedIndex,
            autoPlay, summary, currentResult, inkbarLeft, showGenerate, showLoading } = this.state;
    	//试题信息
    	const interviewQuesVOs = paperInfo.interviewQuesVOs;

        // 国际化
        if(!i18n) return null;

        //报告未生成提示
        const reportTips = (
            userInfo.reportStatus == 3 ?
            <p className="report-fail">{i18n.report.reportFail}</p> :
            (
                (userInfo.reportStatus == 0 || userInfo.reportStatus == 2) ? "" :
                <p style={{color: hex2Rgba(themeColor, 0.5)}}>{i18n.report.reportGenerate}</p>
            )
        )

        return (
        	<React.Fragment>
	        	{finishStatus >= 0 ? <div className="video-mobile-wrap">
					{
                        userInfo.aiVaild === 1 || userInfo.reportStatus !== 0 ?
                        <React.Fragment>
                            <Tabs themeColor={themeColor}
                                  inkbarLeft={inkbarLeft}
                                  wrapClass="video-tabs"
								  moblie="app"
                                  ref={this.tabRef}
                                  tabBarExtraContent={reportTips}
                                  onTabChange={this.handleTabChange}
                                  tabExtraContent={
                                  	<React.Fragment>
                                      <VideoPlayer
                                          handleCanPlay={this.canPlay}
                                          handleEnded={this.playEnd}
                                          forward={this.forward}
                                          backward={this.backward}
                                          autoPlay={autoPlay}
                                          handleTimeUpdate={this.handleTimeUpdate}
                                          videoUrl={this.state.videoUrl}
                                          themeColor={themeColor} />
									</React.Fragment>
								  }
							>
                                <TabPanel tab={i18n.report.originalVideo}>
									<PrimaryVideo
                                        themeColor={themeColor}
                                        i18n={i18n}
                                        userInfo={userInfo}
                                        showMorePaperinfo={showMorePaperinfo}
                                        interviewQuesVOs={interviewQuesVOs}
                                        selectedIndex={selectedIndex}
                                        paperInfo={paperInfo}
                                        showPaperinfo={this.showPaperinfo}
                                        handleClick={(qId, index)=>{this.handleClick(qId, index)}}
									/>
								</TabPanel>
                                <TabPanel tab={i18n.report.liveAnalysis} hidden={userInfo.reportStatus != 2}>
                                  {userInfo.emoProducer === 'human' && <Bulk data={currentResult} i18n={i18n} />}
                                </TabPanel>
                                <TabPanel tab={i18n.report.analysisReport} hidden={userInfo.reportStatus != 2}>
                                  {userInfo.emoProducer === 'human' && <Report summary={summary} themeColor={themeColor} i18n={i18n} />}
                                    <div className="paper-download-wrap" style={userInfo.emoProducer === 'human' ? {} : {marginTop: '0.15rem'}}>
                                        <button style={{color: "#fff", background: themeColor}} onClick={this.downloadReport}>{i18n.report.viewReport}</button>
                                    </div>
                                </TabPanel>
							</Tabs>
                            {
                                userInfo.aiVaild === 1 && showGenerate && userInfo.reportStatus === 0 &&
                                <div className="paper-generate-wrap">
                                    <Button loading={showLoading} style={{color: "#fff", background: themeColor}} onClick={this.generateReport}>
								        {showLoading ? i18n.report.generate : i18n.report.generateReport}
                                    </Button>
                                </div>
                            }
                        </React.Fragment> :
                        <React.Fragment>
                            <VideoPlayer
                                handleCanPlay={this.canPlay}
                                handleEnded={this.playEnd}
                                forward={this.forward}
                                backward={this.backward}
                                autoPlay={autoPlay}
                                handleTimeUpdate={this.handleTimeUpdate}
                                videoUrl={this.state.videoUrl}
                                themeColor={themeColor} />
                            <PrimaryVideo
                                themeColor={themeColor}
                                i18n={i18n}
                                userInfo={userInfo}
                                showMorePaperinfo={showMorePaperinfo}
                                interviewQuesVOs={interviewQuesVOs}
                                selectedIndex={selectedIndex}
                                paperInfo={paperInfo}
                                showPaperinfo={this.showPaperinfo}
                                handleClick={(qId, index)=>{this.handleClick(qId, index)}}
                            />
                        </React.Fragment>
					}
	        	</div>: (finishStatus < 0 ? null : <div className="video-nodata-wrap">
					<h3 className="video-nodata-info">{i18n.result.recordNotFinish}</h3>
				</div>)}
			</React.Fragment>
        );
    }
}

export default App;
